const arr =[{
	path:'details',
	component: resolve => {
		require(['../../../views/inner/product/msci/details.vue'], resolve)
	}
},
{
	path:'list',
	component: resolve => {
		require(['../../../views/inner/product/msci/list.vue'], resolve)
	}
}]

export default arr


// WEBPACK FOOTER //
// ./src/router/inner/product/msci.js